import React, { createContext, useContext, useState } from 'react';

const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      products: 'Produits',
      whySunpower: 'Pourquoi Thermasol',
      findInstaller: 'Trouver un Installateur',
      calculator: 'Calculateur',
      contact: 'Contact'
    },
    hero: {
      title: 'Construisez un avenir plus intelligent et plus radieux',
      subtitle: 'avec les solutions Thermasol Air Systems®',
      cta: 'Trouver un Installateur',
      learnMore: 'En savoir plus'
    },
    features: {
      title: 'Dites oui à un meilleur solaire',
      subtitle: "De l'efficacité à la fiabilité en passant par le design, il n'y a pas de meilleur choix en matière de solaire.",
      feature1: {
        title: 'Électricité + air chaud sur le même panneau',
        desc: 'Le panneau PVT air Thermasol 550 produit 550 Wc d\'électricité et 1 397 Wth de chaleur : l\'air circulant en sous-face est réchauffé et insufflé directement dans votre séchoir ou votre bâtiment.'
      },
      feature2: {
        title: 'Une technologie certifiée et déposée INPI',
        desc: 'Panneau certifié Solar Keymark, IEC 61215 et IEC 61730, sans glycol ni fluide caloporteur. technologie hybride déposée (INPI), conforme à la fiche CEE AGRI-EQ-110.'
      },
      feature3: {
        title: 'Clé en main, du calcul à la prime',
        desc: 'Étude de dimensionnement gratuite (données PVGIS), fourniture, pose, mise en service et montage complet de votre dossier de prime CEE AGRI-EQ-110.'
      }
    },
    products: {
      title: 'Nos Solutions Solaires',
      residential: 'Pour les Particuliers',
      commercial: 'Pour les Entreprises',
      efficiency: 'Efficacité',
      warranty: 'Garantie',
      years: 'ans',
      learnMore: 'En savoir plus'
    },
    testimonials: {
      title: 'Ce que nos clients disent',
      subtitle: 'Découvrez les témoignages de ceux qui ont fait confiance à Thermasol Air Systems®'
    },
    calculator: {
      title: 'Calculez vos économies solaires',
      subtitle: 'Estimez votre potentiel d\'économies avec une installation Thermasol Air Systems®',
      roofArea: 'Surface de toiture disponible (m²)',
      orientation: 'Orientation du toit',
      south: 'Sud',
      east: 'Est',
      west: 'Ouest',
      north: 'Nord',
      electricityBill: 'Facture électrique mensuelle (€)',
      location: 'Région',
      propertyType: 'Type de propriété',
      residential: 'Résidentiel',
      commercial: 'Commercial',
      calculate: 'Calculer mes économies',
      results: {
        panels: 'Panneaux estimés',
        systemSize: 'Puissance du système',
        production: 'Production annuelle',
        savings: 'Économies annuelles',
        payback: 'Retour sur investissement',
        co2: 'Réduction CO₂',
        roi: 'ROI sur 25 ans'
      }
    },
    installer: {
      title: 'Trouvez un installateur près de chez vous',
      subtitle: 'Notre réseau d\'installateurs certifiés couvre toute la France',
      certified: 'Certifié Thermasol®',
      viewDetails: 'Voir les détails',
      contact: 'Contacter'
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Notre équipe est là pour répondre à toutes vos questions',
      name: 'Nom complet',
      email: 'Email',
      phone: 'Téléphone',
      message: 'Message',
      requestType: 'Type de demande',
      types: {
        contact: 'Question générale',
        quote: 'Demande de devis',
        partner: 'Devenir partenaire'
      },
      submit: 'Envoyer',
      success: 'Message envoyé avec succès !'
    },
    footer: {
      tagline: 'Construisez un avenir plus radieux avec Thermasol Air Systems®',
      products: 'Produits',
      company: 'Entreprise',
      support: 'Support',
      legal: 'Mentions légales',
      privacy: 'Politique de confidentialité',
      terms: 'Conditions d\'utilisation',
      copyright: '© 2026 Thermasol Air Systems. Tous droits réservés.'
    },
    chat: {
      title: 'Assistant Thermasol®',
      placeholder: 'Posez votre question...',
      welcome: 'Bonjour ! Comment puis-je vous aider aujourd\'hui ?'
    }
  },
  en: {
    nav: {
      home: 'Home',
      products: 'Products',
      whySunpower: 'Why Thermasol',
      findInstaller: 'Find an Installer',
      calculator: 'Calculator',
      contact: 'Contact'
    },
    hero: {
      title: 'Build a smarter, brighter future',
      subtitle: 'with Thermasol Air Systems® solutions',
      cta: 'Find an Installer',
      learnMore: 'Learn more'
    },
    features: {
      title: 'Say yes to better solar',
      subtitle: 'From efficiency to reliability to design, there is no better choice in solar.',
      feature1: {
        title: 'Electricity + hot air from the same panel',
        desc: 'The Thermasol 550 PVT air panel delivers 550 Wp of electricity and 1,397 Wth of heat: the air flowing under the panel is warmed and blown directly into your dryer or building.'
      },
      feature2: {
        title: 'Certified technology, registered with the INPI',
        desc: 'Solar Keymark, IEC 61215 and IEC 61730 certified panel, with no glycol or heat-transfer fluid. Hybrid technology registered with the INPI, compliant with the AGRI-EQ-110 energy-savings scheme.'
      },
      feature3: {
        title: 'Turnkey, from sizing to subsidy',
        desc: 'Free sizing study (PVGIS data), supply, installation, commissioning and full preparation of your AGRI-EQ-110 subsidy file.'
      }
    },
    products: {
      title: 'Our Solar Solutions',
      residential: 'For Homeowners',
      commercial: 'For Businesses',
      efficiency: 'Efficiency',
      warranty: 'Warranty',
      years: 'years',
      learnMore: 'Learn more'
    },
    testimonials: {
      title: 'What our customers say',
      subtitle: 'Discover testimonials from those who trusted Thermasol Air Systems®'
    },
    calculator: {
      title: 'Calculate your solar savings',
      subtitle: 'Estimate your potential savings with a Thermasol Air Systems® installation',
      roofArea: 'Available roof area (m²)',
      orientation: 'Roof orientation',
      south: 'South',
      east: 'East',
      west: 'West',
      north: 'North',
      electricityBill: 'Monthly electricity bill (€)',
      location: 'Region',
      propertyType: 'Property type',
      residential: 'Residential',
      commercial: 'Commercial',
      calculate: 'Calculate my savings',
      results: {
        panels: 'Estimated panels',
        systemSize: 'System size',
        production: 'Annual production',
        savings: 'Annual savings',
        payback: 'Payback period',
        co2: 'CO₂ reduction',
        roi: '25-year ROI'
      }
    },
    installer: {
      title: 'Find an installer near you',
      subtitle: 'Our network of certified installers covers all of France',
      certified: 'Thermasol® Certified',
      viewDetails: 'View details',
      contact: 'Contact'
    },
    contact: {
      title: 'Contact us',
      subtitle: 'Our team is here to answer all your questions',
      name: 'Full name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      requestType: 'Request type',
      types: {
        contact: 'General inquiry',
        quote: 'Quote request',
        partner: 'Become a partner'
      },
      submit: 'Send',
      success: 'Message sent successfully!'
    },
    footer: {
      tagline: 'Build a brighter future with Thermasol Air Systems®',
      products: 'Products',
      company: 'Company',
      support: 'Support',
      legal: 'Legal notice',
      privacy: 'Privacy policy',
      terms: 'Terms of use',
      copyright: '© 2026 Thermasol Air Systems. All rights reserved.'
    },
    chat: {
      title: 'Thermasol® Assistant',
      placeholder: 'Ask your question...',
      welcome: 'Hello! How can I help you today?'
    }
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr');

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
